import { Router } from '@angular/router';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Job } from '../../models/job.model';
import * as jobsActions from '../../actions/jobs.actions';
import { Store } from '@ngrx/store';
import * as fromJobs from '../../reducers';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

const BUTTONS = [
  { title_translation_key: 'post_job_button_drafts', value: 'is_draft' },
  {
    title_translation_key: 'post_job_button_use_template',
    value: 'is_template',
  },
  {
    title_translation_key: 'post_job_button_use_prev_posting',
    value: 'is_published',
  },
];

const draftsFilter = {
  is_draft: true,
  is_template: false,
};

const templatesFilter = {
  is_draft: true,
  is_template: true,
  is_published: false,
};

const publishedJobsFilter = {
  is_draft: false,
  is_template: false,
};

@Component({
  selector: 'mj-post-job-intro',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './post-job-intro.component.html',
  styleUrls: ['post-job-intro.component.scss'],
})
export class PostJobIntroComponent implements OnInit {
  @Input() jobs: Job[];
  @Output() createJob: EventEmitter<boolean> = new EventEmitter();
  public searchTerm: string = '';
  public isTemplate = false;
  public filter;
  public selectedButtonIndex = 0;
  public btnDisabled = false;

  constructor(
    private store: Store<fromJobs.State>,
    private _router: Router,
    private translate: TranslateService
  ) {
    this.isTemplate =
      (this._router.getCurrentNavigation().extras &&
        this._router.getCurrentNavigation().extras &&
        this._router.getCurrentNavigation().extras.state &&
        this._router.getCurrentNavigation().extras.state.isTemplate) ||
      false;
    this.filter = this.isTemplate ? templatesFilter : publishedJobsFilter;
    this.selectedButtonIndex = this.isTemplate ? 1 : 0;
  }

  private translateButtons(buttons: any[]): any[] {
    return buttons.map(button => {
      this.translate.get(button.title_translation_key).subscribe(text => {
        button.title = text;
      });
      return button;
    });
  }

  ngOnInit() {}

  startFromScratchHandler() {
    if (this.btnDisabled) {
      return;
    }
    this.btnDisabled = true;
    this.createJob.emit(this.isTemplate);
  }

  radioButtonValueChangeHandler($event: string) {
    if ($event === 'is_draft') {
      this.filter = draftsFilter;
    } else if ($event === 'is_template') {
      this.filter = templatesFilter;
    } else if ($event === 'is_published') {
      this.filter = publishedJobsFilter;
    }
  }

  onSearchJob(val: string) {
    this.searchTerm = val;
  }

  get buttons() {
    return this.translateButtons(BUTTONS);
  }

  startFromJob(job: Job) {
    if ((!this.isTemplate && job.is_template) || !job.is_draft) {
      this.store.dispatch(
        new jobsActions.CloneTemplateAsJob({
          jobId: job.id,
        })
      );
    } else {
      this._router.navigate([`/dashboard/jobs/${job.id}`]);
    }
  }

  showPreview(jobId: number) {
    if (jobId) {
      window.open(`${environment.jobShareUrl}${jobId}/`);
    }
  }
}
